'use client';

import { ButtonProps } from '@stadionhq-v3/base-ui';
import { Button } from '../../button.component';

export const TextButton = (props: ButtonProps) => (
  <Button variant="text-button" {...props} />
);
